import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import scoresReducer from '../reducers/scores-reducer';
import createGtmMiddleware from '../middleware/gtm';

const createScoresStore = () => {
  const middlewares = [createGtmMiddleware()];

  return createStore(
    scoresReducer,
    composeWithDevTools(applyMiddleware(...middlewares)),
  );
};

export default createScoresStore;
